import { TranslationValues } from '../models/ITranslationValues';
import { ApiCall } from './ApiCall';
import store from './store';

class TranslationsController {
  private values: TranslationValues;

  async getValues(): Promise<TranslationValues> {
    if (this.values) {
      return this.values;
    } else {
      this.values = await this.fetchTranslations();
      return this.values;
    }
  }

  getLocale(element: HTMLElement = document.body) {
    if (store.langIso && store.langIso != '') {
      return store.langIso;
    } else {
      const closestElement = element.closest('[lang]') as HTMLElement;
      return closestElement ? closestElement.lang : 'ro';
    }
  }

  async fetchTranslations(): Promise<TranslationValues> {
    const locale = this.getLocale();
    try {
      const result = ApiCall.instance.GetTranslations(locale);
      if (result) {
        return result;
      }
    } catch (exception) {
      console.error(`Error loading locale: ${locale}`, exception);
      return null;
    }
  }
}

export const Translations = new TranslationsController();
